export const listenForViteEvents = () => {
  window.addEventListener('vite:preloadError', () => {
    window.location.reload() // for example, refresh the page
  })
}
